import { fetch } from '../utils/fetch'

export function getAddonList() {
  return fetch({
    url: 'addon/queryList',
    method: 'get'
  })
}
